import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import documentValidated, {
	type DocumentValidatedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentValidated';
import documentValidationFailed, {
	type DocumentValidationFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentValidationFailed';
import type ValidateDocument from '@Application/Beneficiaries/Documents/Commands/ValidateDocument';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentValidatedAction | DocumentValidationFailedAction;

export default (command: ValidateDocument) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<DocumentDetailPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/documents/${command.documentId}/validations`,
				{},
			);

			const action = documentValidated(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentValidationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
